<template>
    <div class="row" v-if="hasSurveySetup && property">
        <div class="col-12">
            <striketrough>
                <h4>Details</h4>
            </striketrough>
        </div>
        <div class="col-12 col-lg-4 text-left">
            <h3>Your home <router-link :to="{name: 'SetupHome', params: {backTo: $route.name}}" class="btn btn-link float-right"><i class="fa fa-pencil" /></router-link></h3>
            
            <h5 class="mt-4">Address:</h5>
            <p class="m-0 text-silver" v-if="property.currentPropertyAddress">{{ property.currentPropertyAddress }}</p>
            <p class="m-0 text-silver">
                {{ property.currentPropertyPostcode.toUpperCase() }}
            </p>
            <h5 class="mt-4">Property type:</h5>
            <p class="m-0 text-silver">
                {{ property.currentPropertyType | titleize(stepOneData.currentPropertyType) }}
            </p>
            <h5 class="mt-4">How large is your property</h5>
            <p class="m-0 text-silver">
                {{ property.currentPropertySize | titleize(stepOneData.currentPropertySize)}}
            </p>
            <h5 class="mt-4">Do you rent or own your home?</h5>
            <p class="m-0 text-silver">
                {{ property.currentPropertyOwnership | titleize(stepOneData.currentPropertyOwnership)}}
            </p>
        </div>
        <div class="col-12 col-lg-4 text-left">
            <h3>Current supply <router-link :to="{name: 'SetupCurrent', params: {backTo: $route.name}}" class="btn btn-link float-right"><i class="fa fa-pencil" /></router-link></h3>
            <h5 class="mt-4">What type of energy do you use?</h5>
            <p class="m-0 text-silver">
                {{ property.usage.currentEnergySource | titleize(stepTwoData.currentEnergySource)}}
            </p>
            <div v-if="energySourceIs('D')">
                <h5 class="mt-4">Are you using the same supplier for Gas and Electricity?</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.currentEnergyBySameSupplier | titleize(stepTwoData.currentEnergyBySameSupplier)}}
                </p>
            </div>
            <div v-if="energySourceIs('D') && property.usage.currentEnergyBySameSupplier === '1'">
                <h5 class="mt-4">Your current energy supplier</h5>
                <p class="m-0 text-silver">
                    {{ dualTariff ? dualTariff.product.supplier.name : "--" }}
                </p>
            </div>
            <div v-if="energySourceIs('D') && property.usage.currentEnergyBySameSupplier === '1'">
                <h5 class="mt-4">Your current energy tariff</h5>
                <p class="m-0 text-silver">
                    {{  dualTariff ? dualTariff.product.title : "--" }}
                </p>
            </div>
            
            <div v-if="energySourceIs('D') && property.usage.currentEnergyBySameSupplier === '1'">
                <h5 class="mt-4">Your Energy payment method</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.currentElectricityPaymentScheme | titleize(stepTwoData.currentPaymentSchemes)}}
                    <br />
                    {{ property.usage.currentElectricityPaymentScheme | titleize(stepTwoData.currentPaymentSchemes, true)}}
                </p>
            </div>
            <div v-if="energySourceIs(['D', 'E'])">
                <h5 class="mt-4">Do you have an Economy 7 meter?</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.currentEconomy7State | titleize(stepTwoData.currentEconomy7State)}}
                </p>
            </div>
    
            <div v-if="energySourceIs('E') || (energySourceIs('D') && property.usage.currentEnergyBySameSupplier === '0')">
                <h5 class="mt-4">Your current Electricity supplier</h5>
                <p class="m-0 text-silver">
                    {{ electricityTariff ? electricityTariff.product.supplier.name : "--" }}
                </p>
            </div>
            <div v-if="energySourceIs('E') || (energySourceIs('D') && property.usage.currentEnergyBySameSupplier === '0')">
                <h5 class="mt-4">Your current Electricity tariff</h5>
                <p class="m-0 text-silver">
                    {{  electricityTariff ? electricityTariff.product.title : "--" }}
                </p>
            </div>
    
            <div v-if="energySourceIs('E') || (energySourceIs('D') && property.usage.currentEnergyBySameSupplier === '0')">
                <h5 class="mt-4">Your Electricity payment method</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.currentElectricityPaymentScheme | titleize(stepTwoData.currentPaymentSchemes)}}
                    <br />
                    {{ property.usage.currentElectricityPaymentScheme | titleize(stepTwoData.currentPaymentSchemes, true)}}
                </p>
            </div>
            <div v-if="energySourceIs('G') || (energySourceIs('D') && property.usage.currentEnergyBySameSupplier === '0')">
                <h5 class="mt-4">Your current Gas supplier</h5>
                <p class="m-0 text-silver">
                    {{ gasTariff ? gasTariff.product.supplier.name : "--" }}
                </p>
            </div>
            <div v-if="energySourceIs('G') || (energySourceIs('D') && property.usage.currentEnergyBySameSupplier === '0')">
                <h5 class="mt-4">Your current Gas tariff</h5>
                <p class="m-0 text-silver">
                    {{  gasTariff ? gasTariff.product.title : "--" }}
                </p>
            </div>
    
            <div v-if="energySourceIs('G') || (energySourceIs('D') && property.usage.currentEnergyBySameSupplier === '0')">
                <h5 class="mt-4">Your Gas payment method</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.currentGasPaymentScheme | titleize(stepTwoData.currentPaymentSchemes)}}
                    <br />
                    {{ property.usage.currentGasPaymentScheme | titleize(stepTwoData.currentPaymentSchemes, true)}}
                </p>
            </div>
            
            <div v-if="energySourceIs('G') || (energySourceIs('D') && property.usage.currentEnergyBySameSupplier === '0')">
                <h5 class="mt-4">Your Gas payment method</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.currentGasPaymentScheme | titleize(stepTwoData.currentPaymentSchemes)}}
                    <br />
                    {{ property.usage.currentGasPaymentScheme | titleize(stepTwoData.currentPaymentSchemes, true)}}
                </p>
            </div>
            <div v-if="energySourceIs(['D', 'E','G'])">
                <h5 class="mt-4">I use "Warm Home Discount"</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.currentWarmHomeState | titleize(stepTwoData.currentWarmHomeState)}}
                </p>
            </div>
        </div>
        <div class="col-12 col-lg-4 text-left">
            <h3>Energy usage  <router-link :to="{name: 'SetupEnergy', params: {backTo: $route.name}}" class="btn btn-link float-right"><i class="fa fa-pencil" /></router-link></h3>
    
    
            <div v-if="energySourceIs(['D', 'E'])">
                <h5 class="mt-4">Do you know how much Electricity you use?</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.averageElectricityUsageUnit | titleize(stepThreeData.usageUnits)}}
                </p>
            </div>
            <div v-if="property.usage.averageElectricityUsageUnit === 'gbp'">
                <h5 class="mt-4">I pay</h5>
                <p class="m-0 text-silver">
                    &pound; {{ property.usage.averageElectricityUsageStandardAmount }}  / {{ property.usage.averageElectricityUsagePeriod | titleize(stepThreeData.usagePeriods) }}
                </p>
            </div>
            <div v-if="property.usage.averageElectricityUsageUnit === 'kwh' && !isUsingE7">
                <h5 class="mt-4">I use</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.averageElectricityUsageStandardAmount }} kWh / {{ property.usage.averageElectricityUsagePeriod | titleize(stepThreeData.usagePeriods) }}
                </p>
            </div>
            <div v-if="property.usage.averageElectricityUsageUnit === 'kwh' && isUsingE7">
                <h5 class="mt-4">In daytime I use</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.averageElectricityUsageDailyAmount }} kWh; / {{ property.usage.averageElectricityUsagePeriod | titleize(stepThreeData.usagePeriods) }}
                </p>
                <h5 class="mt-4">In nighttime I use</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.averageElectricityUsageNightlyAmount }} kWh; / {{ property.usage.averageElectricityUsagePeriod | titleize(stepThreeData.usagePeriods) }}
                </p>
            </div>
    
            <div v-if="energySourceIs(['D','G'])">
                <h5 class="mt-4">Do you know how much Gas you use?</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.averageGasUsageUnit | titleize(stepThreeData.usageUnits)}}</p>
            </div>
    
            <div v-if="property.usage.averageGasUsageUnit === 'gbp'">
                <h5 class="mt-4">I pay</h5>
                <p class="m-0 text-silver">
                    &pound; {{ property.usage.averageGasUsageAmount }}  / {{ property.usage.averageGasUsagePeriod | titleize(stepThreeData.usagePeriods) }}
                </p>
            </div>
            <div v-if="property.usage.averageGasUsageUnit === 'kwh'">
                <h5 class="mt-4">I use</h5>
                <p class="m-0 text-silver">
                    {{ property.usage.averageGasUsageAmount }} kWh / {{ property.usage.averageGasUsagePeriod | titleize(stepThreeData.usagePeriods) }}
                </p>
            </div>
            <div v-if="energySourceIs(['D','E'])">
                <h5 class="mt-4">Would you like to use Electricity ONLY from Renewable Sources?</h5>
                <p class="m-0 text-silver">
                  {{ property.usage.preferRenewableSources | titleize(stepThreeData.preferRenewableSources) }}
                </p>
            </div>
        </div>
        <div class="col-12">
            <hr>
        </div>
    </div>
</template>

<script>
import Striketrough from "@/components/support/Striketrough";
import {mapGetters} from "vuex";
import api from "@/utils/api";
import {each} from 'lodash'

export default {
    name: "SurveyDetails",
    components: {Striketrough},
    data() {
        return {
            suppliers: [],
            property: null,
            dualTariff: null,
            electricityTariff: null,
            gasTariff: null,
            
        }
    },
    computed: {
        ...mapGetters('setup', [
            'stepOneData',
            'stepTwoData',
            'stepThreeData'
        ]),
        hasSurveySetup() {
            return !this.$store.getters['setup/isDataEmpty'];
        },
        selectedPropertyType: function () {
            let filtered = this.stepOneData.currentPropertyType.filter((value => value.id === this.property.usage.currentPropertyType));
            return filtered.pop() || {title: ''};
        },
        isUsingE7: function () {
            return this.property.usage.currentEconomy7State === '1'
        }
    },
    methods: {
        energySourceIs: function (sourceType) {
            if (!Array.isArray(sourceType)) {
                sourceType = [sourceType]
            }
            return sourceType.indexOf(this.property.usage.currentEnergySource) >= 0
        },
        setProperty(property){
            this.property = property
            
            let choice = this.$store.getters['setup/choice']
            each(Object.keys(choice), function (key){
                try {
                    choice[key] = property[key] || property.usage[key]
                } catch (e) {
                    console.log(e);
                }
            })
            this.$store.commit('setup/setChoice', choice)
    
            let payload = JSON.parse( atob(choice.currentPropertyAddressPayload));
            const addressDetails = {
                line1: payload.full,
                town: payload.town,
                postcode: payload.postcode
            }
            this.$store.commit('setup/setAddress', addressDetails)
        }
    },
    filters: {
        titleize(value, options, description = false) {
            let filtered = options.filter((option => option.id === value));
            
            if(filtered){
                if(description){
                    return filtered.pop().description
                }
                return filtered.pop().title
                
                
            }
            return "--"
        }
    },
    mounted() {
        let that = this;
        if (this.$store.getters['setup/isDataEmpty']) {
            api.survey().then(response => {
                that.$store.commit('setup/setData', response.data.data)
            })
        }
        api.suppliers().then(result => {
            that.suppliers = result.data.data;
            that.$store.commit('setup/setSuppliers', result.data.data)
        })
        api.property('latest').then(result =>{
            that.setProperty(result.data.data)
            
            api.propertyTariff(that.property.id).then(result => {
                that.dualTariff = result.data.data.d || result.data.data.e;
                that.electricityTariff = result.data.data.e;
                that.gasTariff = result.data.data.g;
            })
        })
    }
}
</script>

<style scoped lang="scss">
h5 > img {
    width: 20px;
}
</style>
